export function initialize() {
    let inputs = document.querySelectorAll('[data-order-qty]');
    if (!inputs.length) return;

    let priceEl = document.querySelector('.table-order .price');

    inputs.forEach(function(input) {
        input.addEventListener('blur', function() {
            recalculate(inputs, priceEl);
        });
        input.addEventListener('keyup', function() {
            recalculate(inputs, priceEl);
        });
        input.addEventListener('click', function() {
            recalculate(inputs, priceEl);
        });
    });
}

function recalculate(inputs, priceEl) {
    let total = 0;
    inputs.forEach(function(input) {
        let qty = parseFloat(input.value) || 0;
        let unitPrice = parseFloat(input.getAttribute('data-value')) || 0;
        total += qty * unitPrice;
    });

    priceEl.textContent = formatPrice(total);
}

function formatPrice(value) {
    return value.toLocaleString('cs-CZ');
}
